import React from 'react'
import styled, { css } from 'styled-components'
import ButtonAlarm from 'components/Button/ButtonAlarm'
import ScheduleBottomOverlay from 'components/Schedule/ScheduleBottomOverlay'
import { dateParser, layoutSmall } from 'core/util/default'

const ScheduleFeed: React.FC<TypeScheduleItem> = (props) => {
  const {
    className,
    thumbnail,
    title,
    broadcastId,
    shopLogo,
    shopName,
    startTime,
    useAlarm,
    etcLinkUrl,
    etcLinkOpenType,
    LinkButtonTagAttributes,
    isShowPurchaseAuthBadge,
    onClickAlarm,
    isConfirmAlarm,
  } = props
  const src = shopLogo + '?h=56&w=56&f=jpg'

  const handleClickAlarm = () => {
    if (!etcLinkUrl) {
      onClickAlarm && onClickAlarm(broadcastId)
      return
    }

    if (etcLinkOpenType === 'move') {
      return (window.location.href = etcLinkUrl)
    }
    if (etcLinkOpenType === 'open') {
      return window.open(etcLinkUrl, '_blank')
    }
    return
  }

  return (
    <StyledScheduleFeed className={className}>
      <button {...LinkButtonTagAttributes} className="schedule_wrapper">
        <ScheduleBottomOverlay isShowPurchaseAuthBadge={isShowPurchaseAuthBadge} />
        <img src={thumbnail} alt={title} />
      </button>
      <div className="info" tabIndex={0}>
        <div className="info_time">{startTime && dateParser(startTime)}</div>
        <div className="info-title">{title}</div>
        <div className="info_profile_wrap">
          <div className="info_profile">
            <div className="thumbnail" style={{ backgroundImage: `url(${src})` }} />
            <span className="info-partner">{shopName}</span>
          </div>
          {useAlarm && <ButtonAlarm isAlarm={isConfirmAlarm} onClick={handleClickAlarm} />}
        </div>
      </div>
    </StyledScheduleFeed>
  )
}

const StyledScheduleFeed = styled.div`
  padding: 0 24px 0 0;
  .schedule_wrapper {
    position: relative;
    display: block;
    width: 384px;
    height: 287px;
    padding: 0;
    border-radius: 4px;
    overflow: hidden;
    background-color: transparent;
    border: solid 1px ${({ theme }) => theme.thumbnailLineColor};
    cursor: pointer;
    img {
      width: inherit;
      height: inherit;
    }
  }
  .info {
    width: 384px;
  }
  .info_time {
    color: ${(props) => props.theme.scheduleTimeFeed};
    margin-top: 5px;
    margin-bottom: 4px;
    font-size: 14px;
    font-weight: 700;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.43;
    letter-spacing: normal;
  }
  .info-title {
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.43;
    letter-spacing: normal;
    line-height: 20px;
    white-space: nowrap;
    font-weight: 600;
    color: ${(props) => props.theme.font.primary};
  }

  .info_profile_wrap {
    margin-top: 4px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .info_profile {
      display: flex;
      align-items: center;
    }

    .thumbnail {
      width: 28px;
      height: 28px;
      border-radius: 50%;
      border: solid 1px ${({ theme }) => theme.thumbnailLineColor};
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      margin-right: 8px;
    }

    .info-partner {
      line-height: 18px;
      color: ${(props) => props.theme.shopNameFont};
      font-size: 12px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: 18px;
    }
  }
  ${layoutSmall(css`
    .info {
      width: 323px;
    }
    .schedule_wrapper {
      width: 323px;
      height: 243px;
    }
  `)}
`
export default ScheduleFeed
